var _defs, _line, _line2, _line3, _line4, _line5, _path, _text, _text2, _rect, _line6, _text3, _rect2, _circle, _text4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPawafleetLogoDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 590,
    height: 160,
    viewBox: "40 100 590 160",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      @import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@700;900&amp;family=Rajdhani:wght@500;600&amp;display=swap');\n    "))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 138,
    x2: 148,
    y2: 138,
    stroke: "#1A3268",
    strokeWidth: 1.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 148,
    x2: 128,
    y2: 148,
    stroke: "#1A3268",
    strokeWidth: 0.7
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 158,
    x2: 108,
    y2: 158,
    stroke: "#1A3268",
    strokeWidth: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 128,
    x2: 118,
    y2: 128,
    stroke: "#1A3268",
    strokeWidth: 0.7
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 118,
    x2: 90,
    y2: 118,
    stroke: "#1A3268",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168 100 L148 148 L164 148 L140 196 L176 138 L160 138 Z",
    fill: "#F47920"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fontFamily: "'Orbitron', 'Arial Black', sans-serif",
    fontWeight: 900,
    fontSize: 62,
    fill: "#E8EEFF",
    x: 192,
    y: 162,
    dominantBaseline: "central",
    textAnchor: "start",
    letterSpacing: -1
  }, "PAWA")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "'Orbitron', 'Arial Black', sans-serif",
    fontWeight: 900,
    fontSize: 62,
    fill: "#F47920",
    x: 408,
    y: 162,
    dominantBaseline: "central",
    textAnchor: "start",
    letterSpacing: -1
  }, "FLEET")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#F47920",
    x: 192,
    y: 194,
    width: 30,
    height: 3,
    rx: 1.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 228,
    y1: 195.5,
    x2: 630,
    y2: 195.5,
    stroke: "#1A3268",
    strokeWidth: 0.6
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "'Rajdhani', 'Trebuchet MS', sans-serif",
    fontWeight: 600,
    fontSize: 12,
    fill: "#4A5F8A",
    x: 192,
    y: 213,
    textAnchor: "start",
    letterSpacing: 3.2
  }, "FLEET MANAGEMENT SYSTEM")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 232,
    width: 210,
    height: 26,
    rx: 5,
    fill: "#1C2340",
    stroke: "#F47920",
    strokeWidth: 1.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 204,
    cy: 245,
    r: 4,
    fill: "#F47920"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "'Rajdhani', 'Trebuchet MS', sans-serif",
    fontWeight: 600,
    fontSize: 11,
    fill: "#F47920",
    x: 213,
    y: 245,
    dominantBaseline: "central",
    textAnchor: "start",
    letterSpacing: 1.6
  }, "COSMOPAWA TECHNOLOGIES")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPawafleetLogoDark);
export default __webpack_public_path__ + "static/media/pawafleet-logo-dark.ab23c4202848b6613b7ab65033432b9f.svg";
export { ForwardRef as ReactComponent };